module.exports = __webpack_public_path__ + "img/tv.bc8929e4.svg";